import React from 'react'
import {Route, Switch} from 'react-router-dom'
import FinancialData from './FinancialData'
import CallNumber from './CallNumber'

export default function Services() {
  return (
    <Switch>
      <Route path="/services/call-number/:token" exact component={CallNumber} />
      <Route path="/services/financial-data" exact component={FinancialData} />
    </Switch>
  )
}
